import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CartingService, IWagon } from '@shared/services/carting.service';
import { ValidatorPatterns } from '@shared/validatorpatterns';

@Component({
	selector: 'app-carting-create-update-wagon-dialog',
	templateUrl: './carting-create-update-wagon.html',
	styleUrls: ['./carting-create-update-wagon.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CartingCreateUpdateWagonDialogComponent implements OnInit {
	@Output() saved = new EventEmitter<void>();
	form: FormGroup;
	wagon: IWagon;
	httpError = '';
	loading = false;
	translationTypes = ['/carting/wagon-types/frame', '/carting/wagon-types/sash'];

	translationLayers = ['/carting/wagon-layers/primary', '/carting/wagon-layers/coupled-b', '/carting/wagon-layers/coupled-c'];

	constructor(
		@Inject(MAT_DIALOG_DATA) public editWagon: IWagon,
		public dialogRef: MatDialogRef<CartingCreateUpdateWagonDialogComponent>,
		private cartingService: CartingService,
		private fb: FormBuilder,
	) {
		this.wagon = {
			self: null,
			name: null,
			description: null,
			batchType: null,
			updatedDate: null,
			updatedBy: null,
			cells: null,
			layer: null,
			translationLayer: null,
			type: null,
			translationType: null,
		};
		if (editWagon) {
			this.wagon = { ...editWagon };
		}
	}

	public ngOnInit(): void {
		this.initializeForm();
	}

	private initializeForm(): void {
		this.form = this.fb.group({
			name: [this.wagon.name, [Validators.required, Validators.maxLength(50), Validators.pattern(ValidatorPatterns.AllowedCuttingCharacters)]],
			description: [this.wagon.description, [Validators.maxLength(100), Validators.pattern(ValidatorPatterns.DanishCharacters)]],
			batchType: [this.wagon.batchType, [Validators.maxLength(255), Validators.pattern(ValidatorPatterns.AllowedCuttingCharacters)]],
			cells: [this.wagon.cells, [Validators.required, Validators.max(10 * 1000)]],
			layer: [this.wagon.layer, [Validators.required]],
			type: [this.wagon.type, [Validators.required]],
		});

		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.wagon) {
					this.wagon[key] = value[key];
				}
			});
		});
	}

	public get controls() {
		return this.form.controls;
	}

	public onCancel(): void {
		this.dialogRef.close();
	}

	public async onSave() {
		this.httpError = '';
		if (this.form.invalid || this.loading) return;
		this.loading = true;

		const saveObservable = this.wagon.self ? this.cartingService.updateWagon(this.wagon) : this.cartingService.createWagon(this.wagon);

		saveObservable.subscribe({
			next: () => {
				this.saved.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}

	getComponent(url: string): string {
		return this.cartingService.getLastSegment(url);
	}
}
